import React from 'react'

export default function FaceFeature({ scaleX, spacing, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`} style={{ opacity: 0.2 }}>
      <g transform={`translate(${-spacing})`}>
        <path
          d="M0.239746 2.66321C2.81975 3.12321 5.28971 3.38325 7.69971 3.08325C8.90971 2.97325 10.0797 2.65314 11.2197 2.22314C12.3897 1.82314 13.4397 1.15318 14.6097 0.513184C13.8797 1.59318 12.9297 2.61319 11.7397 3.27319C11.4597 3.46319 11.1597 3.63316 10.8397 3.74316C10.5197 3.87316 10.2097 4.02318 9.88971 4.13318C9.22971 4.32318 8.56971 4.49323 7.88971 4.56323C6.52971 4.70323 5.15974 4.63322 3.85974 4.30322C2.54974 3.99322 1.29975 3.47321 0.239746 2.66321Z"
          fill={outline}
        />
      </g>{' '}
      <g transform={`translate(${spacing})`}>
        <path
          d="M43.5099 2.66321C42.4499 3.47321 41.1999 3.98323 39.8999 4.31323C38.5999 4.64323 37.2299 4.72324 35.8699 4.57324C35.1899 4.49324 34.5299 4.32319 33.8699 4.14319C33.5499 4.03319 33.2399 3.88317 32.9199 3.75317C32.5999 3.63317 32.2999 3.4732 32.0199 3.2832C30.8199 2.6232 29.8799 1.61319 29.1499 0.523193C30.3199 1.16319 31.3699 1.83315 32.5399 2.23315C33.6799 2.66315 34.8499 2.98314 36.0599 3.09314C38.4599 3.38314 40.9199 3.12321 43.5099 2.66321Z"
          fill={outline}
        />
      </g>
    </g>
  )
}
